import { c as _c } from "react/compiler-runtime";
import type { ReactNode, JSX } from 'react';
import { ErrorBoundary } from './error-boundary';
import { ErrorOverlay } from './error-overlay';
import { isNextApiErrorLike } from '../next-api-error/error';
interface Props {
  children: ReactNode;
  onError?: (error: Error) => unknown;
}

/**
 * This will catch any NextApiError that is thrown (outside of event handlers) and render a nice error message to the
 * user. This should wrap your application.
 */
export function NextApiErrorBoundary(props) {
  const $ = _c(5);
  const {
    children,
    onError
  } = props;
  let t0;
  if ($[0] !== children) {
    t0 = error => {
      if (error && isNextApiErrorLike(error)) {
        return <ErrorOverlay error={error} />;
      }
      return children;
    };
    $[0] = children;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== onError || $[3] !== t0) {
    t1 = <ErrorBoundary onError={onError}>{t0}</ErrorBoundary>;
    $[2] = onError;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}